import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, FormGroup, Input, Label, Row, Container } from "reactstrap";
import ReactStrapTable from "components/reactStrapTable";
import Arrow from "assets/icon/LeftChevron.svg";
import useAxios from "hooks/useAxios";
import { dateFormate } from "utils/columns";
import { cloneDeep } from "lodash";
import Confirm from "components/Confirm";
import { toast } from "react-toastify";
import { Field } from "formik";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import ErrorBoundary from "components/ErrorBoundary";
import { Tabs } from "react-bootstrap";
import { Tab } from "bootstrap";
import ConfigurationsWholeSaler from "pages/Configuration/components/ConfigurationsWholeSaler"
import ConfigurationRules from "../ConfigutationRules";


const ConfigurationsTabs = ({
    setClientCongigToggle,
    thirdPartyAdminID,
    SelectedChainPharmacyvalue,
    searchTerms, 
    setConfigRules,
    data,
    setRowConfig,
    refetch,
    search 
}) => {
 
    const [key, setKey] = useState('Rules');
    const [reset, setReset] = useState(false);

    const onKeyChange = (k) => {
        setKey(k);
        setReset(!reset);
    }

    return (
        <div className=' bin_info'>

            <Card className="border-0 shadow-top my-3">
                <CardBody className="section-devider-border">
                    <Tabs
                        id="controlled-tab-example"
                        className='m-0'
                        activeKey={key}
                        onSelect={(k) => onKeyChange(k)}
                    >
                        <Tab eventKey="Rules" title="Rules">
                            <ErrorBoundary>
                                <ConfigurationRules
                                    setConfigRules={setConfigRules}
                                    setRowConfig={setRowConfig}
                                    setClientCongigToggle={setClientCongigToggle}
                                    thirdPartyAdminID={thirdPartyAdminID}
                                    SelectedChainPharmacyvalue={SelectedChainPharmacyvalue} />
                            </ErrorBoundary>
                        </Tab>
                        <Tab eventKey="Wholesaler" title="Wholesaler">
                            <ErrorBoundary>
                                <ConfigurationsWholeSaler
                                thirdPartyAdminID = {thirdPartyAdminID}
                                searchTerms = {searchTerms}
                                data = {data}
                                SelectedChainPharmacyvalue = {SelectedChainPharmacyvalue}
                                search={search}
                                />
                            </ErrorBoundary>
                        </Tab>


                    </Tabs>


                </CardBody>
            </Card>

        </div>
    );
};

export default ConfigurationsTabs;
